module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_c('div', {
    staticClass: "edit_top"
  }, [_c('div', {
    staticClass: "edit_tab",
    class: {
      'active_tab': _vm.isStep === 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("供应商信息")]), _c('div', {
    staticClass: "edit_tab",
    class: {
      'active_tab': _vm.isStep === 2
    },
    on: {
      "click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_vm._v("品牌信息")]), _c('div', {
    staticClass: "edit_tab",
    class: {
      'active_tab': _vm.isStep === 3
    },
    on: {
      "click": function($event) {
        _vm.changeTab(3)
      }
    }
  }, [_vm._v("财务信息")]), _c('div', {
    staticClass: "edit_tab",
    class: {
      'active_tab': _vm.isStep === 4
    },
    on: {
      "click": function($event) {
        _vm.changeTab(4)
      }
    }
  }, [_vm._v("合同协议")])]), _vm._v(" "), _c('div', {
    staticClass: "tip_word"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("友情提示：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("1.请按照大V服务平台信息要求填写正确的供应商信息。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("3.提交审核之后，大V店工作人员会在3个工作日内进行审核。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("4.入驻过程有任何疑问，请按照如下方式解决："), _c('br'), _vm._v("（1）如果有对接的采销，请直接联系采销处理解决；"), _c('br'), _vm._v("（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("5."), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/suppliers/index2/#/intro"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#58b7ff"
    }
  }, [_vm._v("点击此处")])]), _vm._v("查看供应商入驻介绍。")])])], 1)], 1), _vm._v(" "), _c('basicInfo', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStep == 1),
      expression: "isStep == 1"
    }],
    ref: "basicTemplate"
  }), _vm._v(" "), _c('brandList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStep == 2),
      expression: "isStep == 2"
    }],
    ref: "brandListTemplate"
  }), _vm._v(" "), _c('financeInfo', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStep == 3),
      expression: "isStep == 3"
    }]
  }), _vm._v(" "), _c('argeementList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStep == 4),
      expression: "isStep == 4"
    }],
    ref: "argeement"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showButton == 1),
      expression: "showButton == 1"
    }],
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStep > 1),
      expression: "isStep > 1"
    }],
    attrs: {
      "type": "primary",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.upPage
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasFirstAudit == 1 && _vm.isStep == 3),
      expression: "authData.hasFirstAudit == 1 && isStep == 3"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.rejectFirstConfirmation
    }
  }, [_vm._v("初审驳回")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasFirstAudit == 1 && _vm.isStep == 3),
      expression: "authData.hasFirstAudit == 1  && isStep == 3"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.auditFirstConfirmation
    }
  }, [_vm._v("初审通过")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasConfirmContract == 1 && _vm.isStep == 4),
      expression: "authData.hasConfirmContract == 1 && isStep == 4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmAuditContract(0)
      }
    }
  }, [_vm._v("同意合同")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasConfirmContract == 1 && _vm.isStep == 4),
      expression: "authData.hasConfirmContract == 1 && isStep == 4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmAuditContract(1)
      }
    }
  }, [_vm._v("不同意合同")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasSecondAudit == 1 && _vm.isStep == 4),
      expression: "authData.hasSecondAudit == 1 && isStep == 4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmRejectQualification(1)
      }
    }
  }, [_vm._v("驳回资质信息")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasSecondAudit == 1 && _vm.isStep == 4),
      expression: "authData.hasSecondAudit == 1 && isStep == 4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmRejectQualification(2)
      }
    }
  }, [_vm._v("驳回合同")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasSecondAudit == 1 && _vm.isStep == 4),
      expression: "authData.hasSecondAudit == 1 && isStep == 4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmRejectQualification(0)
      }
    }
  }, [_vm._v("通过复审")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authData.hasEditContract == 1 && _vm.isStep == 4),
      expression: "authData.hasEditContract == 1 && isStep == 4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushContract
    }
  }, [_vm._v("推送合同给供应商")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStep < 4),
      expression: "isStep < 4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("下一页"), _c('i', {
    staticClass: "el-icon-arrow-right el-icon--right"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4458e7a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierapply/audit/supplierCommonPages.vue
// module id = 519
// module chunks = 0